import React, { useState, useRef, useCallback } from 'react';
import { useSidebar } from '../../contexts/SidebarContext';
import { useClickOutside } from '../../hooks/useClickOutside';
import { ChevronsLeft, ChevronsRight, X, Pin } from 'lucide-react';

const SidebarToggle: React.FC = () => {
  const {
    isCollapsed, toggleSidebar, sidebarMode, setSidebarMode,
    isMobile, isDesktopOverlayOpen, closeDesktopOverlay,
  } = useSidebar();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const closePopover = useCallback(() => setIsPopoverOpen(false), []);
  useClickOutside(wrapperRef, closePopover, isPopoverOpen);

  if (isMobile) return null;

  const isOverlayMode = sidebarMode === 'hidden' && isDesktopOverlayOpen;
  const chevronRotation = isCollapsed ? 'rotate(180deg)' : 'rotate(0)';

  const popoverItems = isOverlayMode
    ? [
        { Icon: Pin, label: 'Закрепить', action: () => { setSidebarMode('expanded'); closeDesktopOverlay(); } },
        { Icon: X, label: 'Закрыть', action: () => closeDesktopOverlay() },
      ]
    : sidebarMode === 'expanded'
      ? [
          { Icon: ChevronsLeft, label: 'Свернуть', action: () => toggleSidebar() },
          { Icon: X, label: 'Скрыть панель', action: () => setSidebarMode('hidden') },
        ]
      : [
          { Icon: ChevronsRight, label: 'Развернуть', action: () => toggleSidebar() },
          { Icon: X, label: 'Скрыть панель', action: () => setSidebarMode('hidden') },
        ];

  return (
    <div
      ref={wrapperRef}
      className="sidebar-toggle-wrapper"
    >
      <button
        className="sidebar-toggle sidebar-toggle--desktop-only"
        onClick={() => setIsPopoverOpen(prev => !prev)}
        aria-label="Опции сайдбара"
        aria-haspopup="menu"
        aria-expanded={isPopoverOpen}
      >
        <svg
          width="16"
          height="16"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          style={{
            transition: 'transform 0.3s ease',
            transform: isOverlayMode ? 'rotate(180deg)' : chevronRotation,
          }}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>
      {isPopoverOpen && (
        <div className="sidebar-toggle-popover" role="menu">
          {popoverItems.map(({ Icon, label, action }) => (
            <button
              key={label}
              className="sidebar-toggle-popover__item"
              role="menuitem"
              onClick={() => { action(); setIsPopoverOpen(false); }}
            >
              <Icon size={14} />
              <span>{label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SidebarToggle;
